<div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
      Dear User,<br><br>
      In case of technical support / issues, <br>
      <ng-container *ngIf="!isBroker"> 
        Please write to <a href="mailto:techsupport@iq2health.com">techsupport@iq2health.com</a> with detailed description (preferably with screenshot)  and we’ll get back to you as soon as possible. <br>
      </ng-container>
      <ng-container *ngIf="isBroker"> 
        Please contact the underwriter of corresponding Insurance company for assistance. <br>
      </ng-container>
      <br>
      Regards <br>
      Team QT.
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">{{closeBtnName}}</button>
  </div>